module.exports = __webpack_public_path__ + "static/media/desktop3.cb39b4cd.png";